// React
import { ReactElement } from 'react';
// Types
import { Slice } from '@utmb/types/slice-handler';
import { SliceQuotesSliderView } from '@utmb/types/index';
// Design System
import { Image } from '@utmb/design-system/image/Image';
import { Col } from '@utmb/design-system/box/Box';
import { Pin } from '@utmb/design-system/pin/Pin';
import { Font } from '@utmb/design-system/text/font';
import { Spacer } from '@utmb/design-system/spacer/Spacer';
// Styles
import styles from './challenge-slider.module.scss';
// Local Components
import SingleRaceSlider from './SingleRaceSlider';

export const ChallengeSlider = (props: Slice<SliceQuotesSliderView>): ReactElement | null => {
    const { id, picture, title, quotes } = props;

    if (!quotes || !quotes.length) return null;

    return (
        <Col id={id} className={styles.container}>
            <Pin.Cover xy={{ zIndex: -1 }}>
                <Image objectFit="cover" layout="fill" image={picture} className={styles.filtered_img} />
            </Pin.Cover>
            <div className="utmb_container">
                <Spacer size="l" />
                <Font.FuturaHeavy mobile="16" className={`${styles.title}${title && title.length > 18 ? ` ${styles.title_long}` : ''}`}>
                    {title}
                </Font.FuturaHeavy>
                <SingleRaceSlider picture={picture} title={title} quotes={quotes} />
            </div>
        </Col>
    );
};
